export enum ETutorialSteps {
  tarefas = 1,
  niveis = 2,
  rotinas = 3
}

export interface ITutorialGameficacaoStore {
  step: ETutorialSteps;
}

export enum ETutorialGameficacaoKeys {
  realizouTutorialGameficacao = "realizouTutorialGameficacao"
}
